export interface User {
    id: string;
    name: string;
    email: string;
}

export interface AuthContextType {
    user: User | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    error: string | null;
    login: (email: string, pass: string) => Promise<void>;
    logout: () => void;
    register: (name: string, email: string, pass: string) => Promise<void>;
    
    // New properties for modal management
    isAuthModalOpen: boolean;
    authModalView: 'login' | 'register';
    openAuthModal: (view: 'login' | 'register') => void;
    closeAuthModal: () => void;
}